module.exports = __webpack_public_path__ + "static/myfirstfathersdayvest-ec1c9f529ca8104ab62a1d255cc1df86.jpeg";